



































































































import {Component, Mixins, Watch} from 'vue-property-decorator';
import TranslatedRouter from '@/mixins/TranslatedRouter';
import {TranslateResult} from 'vue-i18n';
import ModalMixin from '@/mixins/ModalMixin';
import Modal from '@/components/Modal.vue';
import ContentSection from '@/components/ContentSection.vue';

import {gsap} from '@/utils/gsap';
import debounce from '@/utils/debounce';

@Component({
	components: {
		'v-modal': Modal,
		'v-content-section': ContentSection,
	}
})
export default class Header extends Mixins(ModalMixin, TranslatedRouter) {

	headerInitial: boolean = false;
	html: HTMLElement | null;
	offset: number = 2;

	clearMobileStyles: boolean = false;

	$refs: {
		headerScope: HTMLElement
		headerNav: HTMLElement
	};

	get cardType(): string |  undefined {
		return this.$route.meta.type || undefined;
	}

	get scrollDir(): number {
		return this.$store.state.scrollToInfo.scrollDir;
	}

	get links(): TranslateResult {
		return this.$t('menu');
	}

	get cards(): TranslateResult {
		return this.$t('footer.product.cards');
	}

	get isMenuOpened(): boolean {
		return this.$store.state.menu.isOpen;
	}

	get headerStyle(): string | undefined {
		return this.$route.meta.headerStyle;
	}

	get headerHeight(): number {
		return this.$store.state.headerInfo.height;
	}

	get hStyle(): string {
		return typeof this.headerStyle === 'undefined' ? 'black' : this.headerStyle;
	}

	get appModalName(): string {
		return this.$t('routes.getApp.modalName') as string;
	}

	get classList(): (string | null)[] {
		return [
			'header',
			this.headerInitial ? 'header--dirty' : null,
			this.isMenuOpened ? 'header--is-open' : null,
			`header--${this.hStyle}`
		]
	}

	get buttonVariant(): string {
		return `secondary secondary-${this.hStyle === 'white-blue' ? 'white' : this.hStyle}`;
	}

	get preloaderState(): boolean {
		return this.$store.state.global.preloaded;
	}

	@Watch('scrollDir')
	onScrollDirrChange(newVal: any) {
		if (this.isMenuOpened) {
			return;
		}
		if (newVal === -1) {
			this.showMenu();
		}
		if (newVal === 1) {
			this.hideMenu();
		}
	}

	@Watch('headerInitial')
	onheaderInitialChange(newVal: number) {
		if (!newVal && this.scrollDir === -1) {

			let tl = gsap.timeline({paused: true});

			tl
				.to(this.$refs.headerScope, {duration: 0.2, autoAlpha: 0})
				.set(this.$refs.headerScope, {
					position: 'absolute',
				})
				.to(this.$refs.headerScope, {duration: 0.3, autoAlpha: 1})
		}
	}

	@Watch('isMenuOpened')
	onMenuStateChanged(newValue: boolean) {
		if (typeof window === 'undefined') {
			return;
		}

		if (!this.html) {
			return;
		}

		if (newValue) {
			gsap.set(this.html, {
				position: 'fixed',
				height: `${window.innerHeight + this.offset}px`,
				overflow: 'hidden'
			});
			gsap.set(this.$refs.headerNav, {
				height: `${window.innerHeight + this.offset}px`,
				overflow: 'scroll'
			});
		} else {
			gsap.set(this.html, {
				clearProps: 'all'
			});
		}
	}

	mounted(): void {

		if (typeof window === 'undefined') {
			return;
		}

		this.html = document.querySelector('html');

		this.getHeaderHeight();

		window.addEventListener('scroll', debounce(this.handleScroll, 50, false));
		window.addEventListener('resize', debounce(this.handleResize, 50, false));

		if (this.checkIfDevice()) {
			window.addEventListener('orientationchange', this.handleOrientation.bind(this));
		}

		if (this.preloaderState) {

			this.$nextTick(() => {
				gsap.timeline().to(this.$refs.headerScope,
					{
						duration: 0.5,
						scale: 1,
						rotationX: 0,
						autoAlpha: 1
					}
				)
			})
		}

		this.$root.$on('isLoaded', (isLoaded: boolean) => {
			if (!isLoaded) {
				return;
			}

			this.afterLoad();
		});
	}

	checkIfDevice(): boolean {
		try {
			document.createEvent('TouchEvent');
			return true;
		} catch (e) {
			return false;
		}
	}

	async handleOrientation(): Promise<void> {

		this.stillMobileMenu();

		if (this.clearMobileStyles) {
			return;
		}

		gsap.set(this.$refs.headerNav, {
			height: `100vh`
		});

		setTimeout(() => {
			gsap.set(this.$refs.headerNav, {
				height: `${window.innerHeight + this.offset}px`,
				overflow: 'scroll'
			});
			setTimeout(() => {
				window.scrollTo(0, 1);
			}, 500);
		}, 500);

	}

	async handleMenu(): Promise<void> {
		await this.$store.dispatch('updateMenu', {
			isOpen: !this.isMenuOpened
		});
	}

	async getHeaderHeight(): Promise<number> {
		if (!this.$refs.headerScope) {
			return 0;
		}

		await this.$store.dispatch('headerInfo', {
			height: this.$refs.headerScope.clientHeight
		});

		return this.headerHeight;
	}

	handleScroll(): void {
		this.headerInitial = window.window.pageYOffset > this.headerHeight;
	}

	async handleResize(): Promise<void> {
		gsap.set(this.$refs.headerNav, {
			height: `${window.innerHeight + this.offset}px`
		});
		await this.stillMobileMenu();
	}

	async stillMobileMenu(): Promise<void> {
		if (window.innerWidth > 899) {
			await gsap.set([this.html, this.$refs.headerNav], {
				clearProps: 'all'
			});
			await this.$store.dispatch('updateMenu', {
				isOpen: false
			});
		}
	}

	showMenu(): void {

		gsap.set(this.$refs.headerScope, {
			position: 'fixed',
			top: -1,
			yPercent: -100
		});

		this.$refs.headerScope.classList.remove('header--inverted');

		gsap.to(this.$refs.headerScope, {
			duration: 0.3,
			yPercent: 0,
		});
	}

	hideMenu(): void {
		gsap.to(this.$refs.headerScope, {yPercent: -100, minHeight: '0px', duration: 0.3});
	}

	afterLoad(): void {
	}

	uCFirst(string: string): string {
		return `${string.charAt(0).toLocaleUpperCase()}${string.slice(1)}`;
	}

	beforeDestroy(): void {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('resize', this.handleResize);
	}
}
